/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { LoggerServiceFactory } from '../../logging/LoggerServiceFactory';
import { AngularLandConnection } from '../base/interfaces';
import { FancyActionTrackerFactory } from '../services/fancy-action-tracker-factory.service';

@Injectable({
	providedIn: 'root',
})
export class DefaultAngularLand implements AngularLandConnection {
	public get angularFireDatabase() {
		return this._angularFireDatabase;
	}
	public get fancyActionTrackerFactory() {
		return this._fancyActionTrackerFactory;
	}
	constructor(
		private _angularFireDatabase: AngularFireDatabase,
		private _fancyActionTrackerFactory: FancyActionTrackerFactory
	) {}
}
